import { LoginFormInputs } from '../interfaces/LoginFormInputs';

export const loginEmpty: LoginFormInputs = {
  username: '',
  password: '',
};
